import Solution from "features/cases/blocks/Solution";
import React, { useState } from "react";
import { useParams } from "react-router-dom";

import PageLayout from "../../common/PageLayout";

function getProblemIdFromQuery(): string | undefined {
  const hashQuery = window.location.hash.includes("?")
    ? window.location.hash.split("?")[1]
    : "";

  return (
    new URLSearchParams(
      hashQuery || window.location.search.replace(/^\?/, ""),
    ).get("problemId") ?? undefined
  );
}

const NewSolutionPage: React.FC = () => {
  const { problemId } = useParams<{ problemId: string }>();
  const effectiveProblemId = problemId ?? getProblemIdFromQuery();

  const [solsExpanded, setSolsExpanded] = useState(false);
  const [probExpanded, setProbExpanded] = useState(false);
  const [caseExpanded, setCaseExpanded] = useState(false);

  return (
    <PageLayout withFooter={false}>
      <Solution
        solutionId={null}
        problemId={effectiveProblemId}
        solsExpanded={solsExpanded}
        setSolsExpanded={setSolsExpanded}
        probExpanded={probExpanded}
        setProbExpanded={setProbExpanded}
        caseExpanded={caseExpanded}
        setCaseExpanded={setCaseExpanded}
        isNewSolutionPage={true}
      />
    </PageLayout>
  );
};

export default NewSolutionPage;
